
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { recordAnalyticsEvent } from '@/services/analyticsService';

interface GameErrorProps {
  errorMessage: string;
  onRetry: () => void;
}

const GameError: React.FC<GameErrorProps> = ({ errorMessage, onRetry }) => {
  // Log error to analytics
  React.useEffect(() => {
    recordAnalyticsEvent('game_error', {
      message: errorMessage,
      game: 'asteroids',
      timestamp: new Date().toISOString()
    });
  }, [errorMessage]);

  const handleRetry = () => {
    // Track retry action
    recordAnalyticsEvent('game_error', {
      action: 'retry',
      message: errorMessage,
      game: 'asteroids'
    });
    onRetry();
  };

  return (
    <div 
      className="w-full h-full flex flex-col items-center justify-center p-6"
      role="alert"
      aria-live="assertive"
    >
      <Alert variant="destructive" className="max-w-md mb-4">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Game Error</AlertTitle>
        <AlertDescription>{errorMessage}</AlertDescription>
      </Alert>
      <p className="text-gray-600 mb-4 text-center">
        We encountered an issue while loading the game. This might be due to a temporary problem.
      </p>
      <Button 
        onClick={handleRetry} 
        className="mt-4"
        aria-label="Retry loading the game"
      >
        Retry
      </Button>
    </div>
  );
};

export default GameError;
